import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { OwnerRotationRoutes } from '../../../routes/HomeRoutes/OwnerRotationRoutes';

export const OwnerRotationLayout = () => <SwitchRoute routes={OwnerRotationRoutes} />;
